import { render, staticRenderFns } from "./SoftphoneHeaderWidget.vue?vue&type=template&id=73fdea92&scoped=true"
import script from "./SoftphoneHeaderWidget.vue?vue&type=script&lang=js"
export * from "./SoftphoneHeaderWidget.vue?vue&type=script&lang=js"
import style0 from "./SoftphoneHeaderWidget.vue?vue&type=style&index=0&id=73fdea92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fdea92",
  null
  
)

export default component.exports